import ExternalLinks from './externallinks'
import AnimatedCounter from './gutenberg-animatedcounter'
import Carousel from './gutenberg-carousel'
import CTA from './gutenberg-cta'
import Events from './gutenberg-events'
import Group from './gutenberg-group'
import Media from './gutenberg-media'
import MiniModal from './gutenberg-minimodal'
import Selector from './gutenberg-selector'
import TabToggleContent from './gutenberg-tabtogglecontent'
import TFOIFA from './gutenberg-tfoifa'
import TextToSpeech from './gutenberg-tts'
import Twitter from './gutenberg-twitter'
import BlockEditorIframe from './gutenberg'

const init = () => {
	window.requestAnimationFrame( () => {
		ExternalLinks()
		AnimatedCounter()
		Carousel()
		CTA()
		Events()
		Group()
		Media()
		MiniModal()
		Selector()
		TabToggleContent()
		TFOIFA()
		TextToSpeech()
		Twitter()
		BlockEditorIframe()
	} )
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init, { once: true } )
} else {
	init()
}
